import { render, staticRenderFns } from "./VrstaSudionikaDetails.vue?vue&type=template&id=71af5439&scoped=true&"
import script from "./VrstaSudionikaDetails.vue?vue&type=script&lang=js&"
export * from "./VrstaSudionikaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71af5439",
  null
  
)

export default component.exports